import { createGlobalStyle } from 'styled-components';

import NunitoRegular from '../assets/fonts/nunito/nunito-regular.ttf';
import NunitoBold from '../assets/fonts/nunito/nunito-bold.ttf';
import NunitoSemiBold from '../assets/fonts/nunito/nunito-semibold.ttf';
import NunitoBlack from '../assets/fonts/nunito/nunito-black.ttf';
import VollkornBold from '../assets/fonts/vollkorn/vollkorn-bold.ttf';
import VollkornBlack from '../assets/fonts/vollkorn/vollkorn-black.ttf';
import IndieFlowerRegular from '../assets/fonts/indie-flower/indie-flower-regular.ttf';

import { screen } from '../variables';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Nunito';
    src: url(${NunitoRegular}) format("truetype");
    font-weight: 400;
  }
    
  @font-face {
    font-family: 'Nunito';
    src: url(${NunitoSemiBold}) format("truetype");
    font-weight: 600;
  }

  @font-face {
    font-family: 'Nunito';
    src: url(${NunitoBold}) format("truetype");
    font-weight: 700;
  }

  @font-face {
    font-family: 'Nunito';
    src: url(${NunitoBlack}) format("truetype");
    font-weight: 900;
  }

  @font-face {
    font-family: 'Vollkorn';
    src: url(${VollkornBold}) format("truetype");
    font-weight: 700;
  }

  @font-face {
    font-family: 'Vollkorn';
    src: url(${VollkornBlack}) format("truetype");
    font-weight: 900;
  }

  @font-face {
    font-family: 'Indie Flower';
    src: url(${IndieFlowerRegular}) format("truetype");
    font-weight: 900;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-size: 20px;
    line-height: 28px;
    margin: 0;
    font-family: 'Nunito', sans-serif;
    color: #464949;
    overflow-y: scroll;

    @media (max-width: ${screen.tablet}px) {
      font-size: 18px;
      line-height: 25px;
    }

    #root {
      box-sizing: border-box;
      min-height: 100vh;
      position: relative;
      padding-bottom: 244px;

      @media (max-width: ${screen.tablet}px) {
        padding-bottom: 368px;
      }

      @media (max-width: 340px) {
        padding-bottom: 534px;
      }
    }

    // only mobile and only desktop
    @media (min-width: ${screen.tablet}px) {
      .only-mobile {
        display: none !important;
      }
    }
    @media (max-width: ${screen.tablet}px) {
      .only-desktop {
        display: none !important;
      }
    }
  }
`;
